import { render, staticRenderFns } from "./consulting01.vue?vue&type=template&id=4ed8cbc6&scoped=true"
import script from "./consulting01.vue?vue&type=script&lang=js"
export * from "./consulting01.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed8cbc6",
  null
  
)

export default component.exports